import {
  TabList,
  TabPanel,
  TabPanels,
  Tabs as ChakraTabs,
  Heading,
} from "@chakra-ui/react";
import { ReactNode, useEffect, useState } from "react";
import { motion } from "framer-motion";

import useViewport from "hooks/useViewport";
import Tab from "./Tab";

export type TabType = {
  tab: {
    text: string;
    icon: ReactNode;
  };
  title?: string;
  content: ReactNode;
};

type TabsProps = {
  listTabs: Array<Omit<TabType, "sx">>;
  indexSelected?: number;
  sameTitleTop?: string;
};

const Tabs = ({ listTabs, indexSelected, sameTitleTop }: TabsProps) => {
  const [tabIndex, setTabIndex] = useState(indexSelected);
  const { isMobile } = useViewport();

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  useEffect(() => {
    setTabIndex(indexSelected);
  }, [indexSelected]);

  return (
    <ChakraTabs
      display="flex"
      // w="100%"
      flexDirection="column"
      variant="unstyled"
      colorScheme="green"
      height="max-content"
      p={0}
      gap={{ base: "32px", md: "40px" }}
      index={tabIndex}
      defaultIndex={indexSelected}
      onChange={(index) => handleTabChange(index)}
    >
      {sameTitleTop && sameTitleTop?.length > 0 && (
        <Heading
          as="h2"
          textAlign="center"
          m={{ md: "0 auto" }}
          pb="8px"
          fontSize="36px"
          maxW={{ base: "100%", md: "555px" }}
        >
          {sameTitleTop}
        </Heading>
      )}

      <TabList
        display="flex"
        borderWidth="1px"
        borderColor="ud-grey-300"
        borderRadius="full"
        maxW={{ base: "100%", md: "932px" }}
        w="100%"
        margin="0 auto"
      >
        {listTabs.map((tab, index) => (
          <Tab key={index} {...tab} />
        ))}
      </TabList>
      <TabPanels p={0}>
        {listTabs.map(({ content, title }, index) => (
          <TabPanel flex={1} key={index} p={0}>
            <motion.div
              initial={!isMobile && { opacity: 0.99, scale: 0.99 }}
              animate={
                !isMobile && index === tabIndex
                  ? { opacity: 1, scale: 1 }
                  : { opacity: 0.99, scale: 0.99 }
              }
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              {!sameTitleTop && (
                <Heading
                  as="h2"
                  display={title ? "block" : "none"}
                  textAlign="center"
                  py="30px"
                  m={{ md: "0 auto" }}
                  fontSize="36px"
                  maxW={{ base: "100%", md: "555px" }}
                >
                  {title}
                </Heading>
              )}
              {content}
            </motion.div>
          </TabPanel>
        ))}
      </TabPanels>
    </ChakraTabs>
  );
};

export default Tabs;
